/**
 * Canonical storefront paths for Treydora.com (TreydoraSiteShell + App.js routes).
 * Homepage and shell nav should import from here to stay aligned with active routes.
 */

export const SITE_HOME_PATH = "/";
export const SITE_WORLD_PATH = "/world";
export const SITE_OSHAR_REAL_ESTATE_PATH = "/world/oshar/real-estate";
export const SITE_MARKETPLACE_PATH = "/marketplace";
export const SITE_PUBLIC_LIBRARY_PATH = "/library";
export const SITE_MY_LIBRARY_PATH = "/dashboard/library";
export const SITE_MY_STORE_PATH = "/dashboard/my-store";
/** Public help / contact hub (shell header "Support"). */
export const SITE_SUPPORT_PATH = "/support";
export const SITE_DASHBOARD_PATH = "/dashboard";
export const SITE_DASHBOARD_SUPPORT_PATH = "/dashboard/support";

/**
 * Treydorex purchase UI: home page section `id="sales"` (TreydorexAccessSection).
 * Use with `react-router-hash-link` HashLink (`smooth`) for in-page scroll.
 */
export const SITE_TOKEN_SALE_HASH_LINK = "/#sales";

/** Vanity path — App.js redirects to SITE_TOKEN_SALE_HASH_LINK */
export const SITE_TOKEN_SALE_PATH = "/token-sale";

/**
 * Legacy vanity URL — App.js redirects to `pathname: "/"`, `hash: "sales"`.
 * Prefer SITE_TOKEN_SALE_HASH_LINK / SITE_NAV_ROUTES.TOKEN_SALE for CTAs.
 */
export const SITE_TREYDOREX_LEGACY_REDIRECT_PATH = "/treydorex";

/**
 * @deprecated Legacy ItemDetail stub — App.js redirects `/item-detail/*` to SITE_PUBLIC_LIBRARY_PATH.
 * Genesis Comic purchase, tiers, and optional wallet mint live on LibraryPage.
 */
export const SITE_COMIC_MINT_PATH = SITE_PUBLIC_LIBRARY_PATH;

/** @deprecated Use SITE_TOKEN_SALE_HASH_LINK + HashLink, or SITE_NAV_ROUTES.TOKEN_SALE */
export const SITE_TREYDOREX_PATH = SITE_TOKEN_SALE_HASH_LINK;

export const SITE_NAV_ROUTES = {
  HOME: SITE_HOME_PATH,
  WORLD: SITE_WORLD_PATH,
  OSHAR_REAL_ESTATE: SITE_OSHAR_REAL_ESTATE_PATH,
  PUBLIC_LIBRARY: SITE_PUBLIC_LIBRARY_PATH,
  DASHBOARD: SITE_DASHBOARD_PATH,
  USER_LIBRARY: SITE_MY_LIBRARY_PATH,
  SUPPORT: SITE_SUPPORT_PATH,
  MY_STORE: SITE_MY_STORE_PATH,
  MARKETPLACE: SITE_MARKETPLACE_PATH,
  TOKEN_SALE: SITE_TOKEN_SALE_HASH_LINK,
};

/** @deprecated Use SITE_MY_LIBRARY_PATH */
export const SITE_COLLECTOR_VAULT_PATH = SITE_MY_LIBRARY_PATH;
/** @deprecated Use SITE_SUPPORT_PATH */
export const SITE_PUBLIC_SUPPORT_PATH = SITE_SUPPORT_PATH;

/** @deprecated Legacy `/explore` — App.js redirects to SITE_PUBLIC_LIBRARY_PATH. */
export const SITE_EXPLORE_PATH = SITE_PUBLIC_LIBRARY_PATH;
